module.exports = __webpack_public_path__ + "img/fi-rr-paint-brush.23a59381.svg";